const EmptyHistoryState = () => {
	return (
		<div className="flex items-center justify-center py-16">
			<p className="text-primary-inactive text-center">
				No history events yet.
				<br />
				Events will appear here as you track this job.
			</p>
		</div>
	);
};

export default EmptyHistoryState;
